import LoanResource from "./loan.resource";

const loanModule = angular
  .module("app.resources.loan", [])
  .service("Loan", LoanResource);

export default loanModule;



// WEBPACK FOOTER //
// ./src/resources/loan/loan.module.js